<template>
  <div class="c-infomationDetail">
    <PageTitle titleText="お知らせ" />
    <div class="c-informationDetail__contents">
      <div class="c-informationDetail__title">
        <div class="c-informationDetail__title__aside">
          <div class="c-informationDetail__title__aside__date">
            {{ $date(info.registration_at).tz().format("YYYY/MM/DD") }}
          </div>
          <div class="c-informationDetail__title__aside__newsTagWrap">
            <NewsTag :tagIndex="info.label" :text="statusText(info.label)" />
          </div>
        </div>
        <!-- <span v-html="createTag(info.label)"></span> -->
        <div class="c-informationDetail__title__text">{{ info.title }}</div>
      </div>

      <div class="c-informationDetail__discription ck-content">
        <div class="" v-html="info.body"></div>
        <!-- <pre class="news-detail-text">{{ info.body }}</pre> -->
        <span class="news-sche-box">
          <span style="font-weight: bold" v-if="info.is_schedule"
            >スケジュール詳細：</span
          >
          <span class="news-detail-sche-detail"
            >{{ $date(info.calender_range.start).tz().format("YYYY/MM/DD HH:mm") }}〜{{
              $date(info.calender_range.end).tz().format("YYYY/MM/DD HH:mm")
            }}
          </span>
        </span>
        <a
          :href="info.url"
          :target="info.url_target ? '_blank' : ''"
          class="c-informationDetail__link"
        >
          {{ info.url_title }}
        </a>
      </div>
    </div>

    <div class="c-informationDetail__buttonWrap">
      <router-link
        :to="{
          name: 'information-1',
          params: { mc_code: currentUser.mansion._id },
        }"
      >
        <Button text="お知らせ一覧へ"></Button>
      </router-link>
    </div>
  </div>
</template>

<script>
import PageTitle from "@/components/PageTitle.vue";
import Button from "@/components/Button.vue";
import NewsTag from "@/components/NewsTag.vue";

export default {
  components: { PageTitle, Button, NewsTag },
  props: {
    info: Object,
  },
};
</script>

<style></style>
